import Wordmark from "./Wordmark";
import { AVATAR_TONES } from "../../lib/avatarTones";

type Variant = "signup" | "login" | "join";

const BRAND_COPY: Record<Variant, { tag: string; headline: string; sub: string }> = {
  signup: {
    tag: "Free to start · no card",
    headline: "Make hydration the new vital sign on your yard.",
    sub: "Track every horse's water, exercise, feed, behaviour and droppings. Spot colic risk days before the vet would.",
  },
  login: {
    tag: "Welcome back",
    headline: "Pick up where you left off.",
    sub: "Twelve horses are waiting for today's log. Two need attention.",
  },
  join: {
    tag: "Joining a yard",
    headline: "One yard, one log per horse, all your team in sync.",
    sub: "Logging is shift-based. Anyone on the rota — morning groom, evening staff, the owner — can log against any horse.",
  },
};

interface BrandPanelProps {
  variant?: Variant;
}

export default function BrandPanel({ variant = "login" }: BrandPanelProps) {
  const copy = BRAND_COPY[variant] || BRAND_COPY.login;

  return (
    <aside className="auth-brand">
      <div className="auth-brand-top">
        <Wordmark />
        <nav className="auth-brand-nav">
          <a href="/sensor">Sensor</a>
          <a href="/#pricing">Pricing</a>
          <a href="/#about">About</a>
        </nav>
      </div>

      <div className="auth-brand-body">
        <span className="auth-brand-tag">
          <span className="auth-brand-dot"></span>
          {copy.tag}
        </span>
        <h2 className="auth-brand-headline">{copy.headline}</h2>
        <p className="auth-brand-sub">{copy.sub}</p>

        <div className="auth-demo">
          <div className="auth-demo-head">
            <span>Hollow Tree · today</span>
            <span>10:42</span>
          </div>
          <div className="auth-demo-row">
            <span className="avatar" style={{ background: AVATAR_TONES.bay }}>H</span>
            <div>
              <div className="auth-demo-name">Henry</div>
              <div className="auth-demo-meta">4L of 50L · droppings + water down</div>
              <div className="auth-demo-bar severe"><span style={{ width: "8%" }}></span></div>
            </div>
            <span className="auth-demo-badge"><span className="dot severe"></span>Severe</span>
          </div>
          <div className="auth-demo-row">
            <span className="avatar" style={{ background: AVATAR_TONES.chestnut }}>B</span>
            <div>
              <div className="auth-demo-name">Bella</div>
              <div className="auth-demo-meta">14L of 45L · on pace</div>
              <div className="auth-demo-bar hydrated"><span style={{ width: "31%" }}></span></div>
            </div>
            <span className="auth-demo-badge"><span className="dot hydrated"></span>Hydrated</span>
          </div>
        </div>
      </div>

      <div className="auth-brand-foot">
        <span>
          Powered by the <strong>EHE algorithm</strong> — from Jack Burbridge's Exeter dissertation.
        </span>
      </div>
    </aside>
  );
}
